import { useDeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId } from '@fukuri-admins/apis/client/gen/endpoints';

export const useDeletePortal = useDeleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId;
